// src/shared/components/PrivateRoute.tsx
import { Navigate } from 'react-router-dom';

import { useAuth } from './AuthProvider';
import { PageSpinner } from './PageSpinner';

export default function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { initializing, isAuthenticated } = useAuth();

  if (initializing) return <PageSpinner />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
